<template>
  <div class="stepper-container">
    <div class="stepper">
      <div v-for="(stepItem, index) in steps" :key="index" class="step" :class="{
        'step-active': currentStep >= stepItem.stepNumber,
        'step-completed': currentStep > stepItem.stepNumber
      }">
        <div class="step-circle">
          <span v-if="currentStep > stepItem.stepNumber" class="pi pi-circle-fill circle"></span>
          <span v-else class="pi pi-circle-fill circle  text-center"></span>
        </div>
        <span class="step-label Label">{{ stepItem.label }}</span>
        <div v-if="index < steps.length - 1" class="step-connector"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
defineProps({
  currentStep: {
    type: Number,
    required: true
  },
  steps: {
    type: Array,
    required: true
  }
});
</script>

<style scoped>
.stepper-container {
  width: 100%;
  padding: 2rem 0;
}

.stepper {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  flex: 1;
}

.step-circle {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: transparent;
  border: 1px solid var(--gray-100);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  color: var(--gray-100);
  transition: all 0.3s ease;
  z-index: 2;
}

.step-active .step-circle {
  background-color: transparent;
  border-color: var(--teal-500) !important;
  color: var(--teal-500) !important;
}

.circle {
  font-size: 10px;
}

.step-completed .step-circle {
  background-color: var(--teal-500);
  border-color: var(--teal-500);
  color: white;
}

.step-completed .circle {
  color: white;
  font-size: 10px !important;
}

.step-label {
  margin-top: 0.5rem;
  color: var(--black-100);
  text-align: center;
  font-weight: 400;
  transition: all 0.3s ease;
}

.step-active .step-label {
  color: var(--teal-500) !important;
  font-weight: 400 !important;
}

.step-completed .step-label {
  color: var(--teal-500);
}

.step-connector {
  position: absolute;
  top: 12px;
  left: 50%;
  transform: translateX(0);
  width: 100%;
  height: 1px;
  background-color: #e9ecef;
  z-index: 1;
}

.step:last-child .step-connector {
  display: none;
}

.step-completed .step-connector {
  background-color: var(--teal-500);
}

/* Responsive design */
@media (max-width: 768px) {
  .stepper {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .step {
    flex-direction: row;
    width: 100%;
    align-items: center;
  }

  .step-label {
    margin-top: 0;
    margin-left: 1rem;
    text-align: left;
  }

  .step-connector {
    display: none;
  }
}
</style>